/**
 *
 *  a dedicated class for doing positioning
 * @param {*} configurations
 * @param {*} context optional document object to cater parent and iframe based DOM manipulation alike
 * @returns
 */

export default class Positioner {
    constructor(configurations, context) {
        const me = this;
        me.configuration = configurations;
        me.DOM = context || document;
    }

    getPureElement(element) {
        if (element.indexOf('.') === -1 && element.indexOf('#') === -1) {
            return element;
        }
        return element.substring(1, element.lenght);
    }

    getElement(element, pureElement) {
        return this.isClass(element)
            ? this.DOM.getElementsByClassName(pureElement)[0]
            : this.DOM.getElementById(pureElement);
    }

    isClass(element) {
        return element.indexOf('.') !== -1;
    }
}
